import { Routes, Route } from "react-router-dom";
import withTenant from "./utils/withTenant";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import NotFound from "./NotFound";
import HeaderNavBar from "./components/layout/HeaderNavBar";
import Footer from "./components/layout/Footer";
import MenuSide from "./components/layout/MenuSide";
import withGuard from "./utils/withGuard";
import { useTenant, useStartup } from "./hooks";
import { MwSpinner } from "./components/ui";
import { prefetchUrl } from "./hooks/useFetch";
import { AccountsMgm } from "./pages/AccountsMgm";
import { AccountsProvider } from "./utils/AccountsHelper";
import { AccountCenter } from "./pages/AccountCenter";
import { AccountCenterProvider } from "./utils/CostCenterAccHelper";
import { TimeMange } from "./pages/TimeMange";
import { PeriodsProvider } from "./utils/TimeMangeHelper";
import { JournalEntry } from "./pages/JournalEntry";
import { JournallEntrymgm } from "./pages/JournallEntrymgm";
import { Dashboard } from "./pages/Dashboard";
import { JournalEntryProvider } from "./utils/JournalEntryHelper";
import { CurrencyProvider } from "./utils/CurrencyHelper";
import { OpeningBalance } from "./pages/OpeningBalance";
import { BalanceProvider } from "./utils/BalanceHalper";
import { AccountsBook } from "./pages/AccountsBook";
import { AccountBookProvider } from "./utils/AccountsBookHelper";
import { Reports } from "./pages/Reports";
import { TrialBalance } from "./reports/TrialBalance";
import { AccountStatement } from "./reports/AccountStatement";
import { ToastContainer } from "react-toastify";
import { UserLevelProvider } from "./utils/UserLevel";
import { Settings } from "./pages/Settings";

function App() {
  const [openMenu, setOpenMenu] = useState(false);
  const langState = useSelector((state) => state.lang);
  const {
    tenant,
    tenantUsername,
    loading: loadingTenant,
    companiesList,
    branchesList,
    tenantId,
    companySelected,
    branchSelected,
  } = useTenant();
  const { startup } = useStartup();

  useEffect(() => {
    if (!startup) return;
    if (!tenantId || !companySelected?.value || !branchSelected?.value) return;
    const taxesUrl = `${process.env.REACT_APP_VAT_WEB_BASE_URL}/sales/taxes/${tenantId}/${companySelected.value}/${branchSelected.value}`;
    prefetchUrl(taxesUrl);
  }, [startup, tenantId, companySelected?.value, branchSelected?.value]);

  return !loadingTenant && startup ? (
    <UserLevelProvider>
      <PeriodsProvider>
        <CurrencyProvider>
          <div
            dir={langState?.value === "ar" ? "rtl" : "ltr"}
            className="h-screen flex flex-col flex-between  "
          >
            <HeaderNavBar
              companySelected={companySelected}
              branchSelected={branchSelected}
              companiesList={companiesList}
              branchesList={branchesList}
              tenantUsername={tenantUsername}
              tenant={tenant}
              openMenu={openMenu}
              setOpenMenu={setOpenMenu}
            />
            <div className="bg-white flex  flex-1 ap  m-auto  w-full">
              <MenuSide openMenu={openMenu} setOpenMenu={setOpenMenu} />
              <div
                className={`flex flex-col flex-1 px-3  py-1 pe-5   primary-bg-color ${openMenu ? "ms-8 md:ms-0 ps-3" : "md:ms-10"} `}
              >
                <div className=" rounded-2xl bg-slate-50  h-[calc(100vh-85px)] overflow-scroll">
                  <Routes>
                    <Route
                      path=":tenant/"
                      element={
                        <AccountCenterProvider>
                          <AccountsProvider>
                            <JournalEntryProvider>
                              <Dashboard />
                            </JournalEntryProvider>
                          </AccountsProvider>
                        </AccountCenterProvider>
                      }
                    />
                    <Route
                      path=":tenant/accountGuide"
                      element={
                        <AccountCenterProvider>
                          <AccountsProvider>
                            <AccountsMgm />
                          </AccountsProvider>
                        </AccountCenterProvider>
                      }
                    />
                    <Route
                      path=":tenant/accountCenter"
                      element={
                        <AccountCenterProvider>
                          <AccountCenter />
                        </AccountCenterProvider>
                      }
                    />
                    <Route path=":tenant/timeMange" element={<TimeMange />} />
                    <Route
                      path=":tenant/JournalEntry"
                      element={
                        <JournalEntryProvider>
                          <JournalEntry />
                        </JournalEntryProvider>
                      }
                    />
                    <Route
                      path=":tenant/dashboard"
                      element={
                        <JournalEntryProvider>
                          <Dashboard />
                        </JournalEntryProvider>
                      }
                    />
                    <Route
                      path=":tenant/Journalmangement"
                      element={
                        <AccountsProvider>
                          <AccountCenterProvider>
                            <JournalEntryProvider>
                              <JournallEntrymgm />
                            </JournalEntryProvider>
                          </AccountCenterProvider>
                        </AccountsProvider>
                      }
                    />

                    <Route
                      path=":tenant/opening-balance"
                      element={
                        <AccountsProvider>
                          <BalanceProvider>
                            <OpeningBalance />
                          </BalanceProvider>
                        </AccountsProvider>
                      }
                    />
                    <Route
                      path=":tenant/accounts-book"
                      element={
                        <AccountsProvider>
                          <AccountBookProvider>
                            <AccountsBook />
                          </AccountBookProvider>
                        </AccountsProvider>
                      }
                    />
                    <Route path=":tenant/reports" element={<Reports />} />
                    <Route
                      path=":tenant/reports/trial-balance"
                      element={<TrialBalance />}
                    />
                    <Route
                      path=":tenant/reports/account-status"
                      element={
                        <AccountsProvider>
                          <AccountStatement />
                        </AccountsProvider>
                      }
                    />
                    <Route
                      path=":tenant/settings"
                      element={
                        <Settings/>
                      }
                    />

                    <Route path="/notfound" errorElement={<NotFound />} />
                    <Route path="/*" errorElement={<NotFound />} />
                  </Routes>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </CurrencyProvider>
        <ToastContainer />
      </PeriodsProvider>
    </UserLevelProvider>
  ) : (
    <MwSpinner />
  );
}

export default withTenant(withGuard(App));
